import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Logo from '../../logos/storage-sprint.png';
import { BiSolidHide, BiSolidShow } from "react-icons/bi";
import { useAuth } from '../../context/AuthContext';


const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const { login } = useAuth();
    const [logoLoaded, setLogoLoaded] = useState(false);

    const handleError = (error) => {
        if (typeof error === 'string') {
            setError(error);
        } else if (error && typeof error.text === 'string') {
            setError(error.text);
        } else {
            setError('An unknown error occurred.');
        }
    };

    const handleLogin = async () => {
        setError('');

        if (!username || !password) {
            setError('Email and password are required.');
            return;
        }

        try {
            await login(username, password);

        } catch (error) {
            handleError(error.message || 'An error occurred while submitting your request.');
        }
    };

    return (
        <>
            <Helmet>
                <title>Sign In | Storage Sprint</title>
                <meta name="description" content="Delivering Flexible Storage at Your Fingertips. Storage Sprint is dedicated to delivering efficient, cost-effective, and scalable storage solutions through innovative technology, simplifying how people store and move their belongings." />
            </Helmet>

            <div className="min-h-screen flex flex-col justify-between bg-white">
                <div className="flex flex-col items-center justify-center px-4 py-8">
                    <div className="w-full max-w-md mt-8 bg-white p-6 rounded-xl shadow-lg">
                    <div className="flex flex-col items-center text-center m-4">
                        <img
                            src={Logo}
                            alt="Logo"
                            className="w-auto h-32 mb-4"

                        />
                        <h2 className="text-xl md:text-2xl font-bold text-yellow-600">SCHEDULE YOUR DELIVERY NOW!</h2>
                    </div>

                        <p className="text-lg text-center font-semibold text-gray-700 mb-4">Login to Storage Sprint</p>

                        <div className="space-y-4">
                            <input
                                id="identifier"
                                type="text"
                                value={username}
                                placeholder="Enter your email"
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                            />

                            <div className="relative">
                                <input
                                    id="password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    placeholder="Enter your password"
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                />
                                <span
                                    className="absolute inset-y-0 right-3 flex items-center text-gray-500 cursor-pointer"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <BiSolidHide /> : <BiSolidShow />}
                                </span>
                            </div>

                            <button
                                onClick={handleLogin}
                                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                            >
                                Continue
                            </button>

                            {error && <div className="text-red-500 text-sm mt-2">{error}</div>}

                            <div className="flex justify-between text-sm text-yellow-600 mt-4">
                                <a href="/forgot-password/" className="hover:underline">Forgot password?</a>
                                <a href="/selection/" className="hover:underline">Create Account</a>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
        </>
    );
};

export default LoginPage;

